import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import { rules } from "../../abac.config";
import { Permission } from "../../abac.config";
import AccessDenied from "../common/AccessDenied";
import { Link } from "react-router-dom";
import { createNotification } from "../helpers/Notification";
import ConfirmBox from '../common/ConfirmBox';
import masterDataService from "../services/MasterDataService";
import { getApiUrl } from "../helpers/Util";
import { setLocalStorageMasterDataItems, getLocalStorageMasterDataItems, removeLocalStorageMasterDataItems } from "../project/Helper";

class FieldMaintenanceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FieldMaintenanceListData: [],
      name: "",
      isShowConfirmBox: false,
      loader: false,
      status: "Active",
      removeId: "",
      resDataLen:0,
      //  pagination constants---------
      
      pageChange: 1,
      skip: 0,
      limit: 10,
      count: 0,

    }
    this.validator = new SimpleReactValidator();
  }
  componentDidMount = () => {
    this.getFieldMaintenancePaginationConstants();
  }

  getFieldMaintenancePaginationConstants=()=>{
    const { skip, limit } = this.state;
        const data = getLocalStorageMasterDataItems("fieldMaintenancePaginationConstants");
        console.log(data);
        let filters
        if (data !== null && data !== undefined) {
    
          const { fieldMaintenanceLimit, fieldMaintenancePageChange, fieldMaintenanceSkip } = data;
          this.setState({ pageChange: fieldMaintenancePageChange, limit: fieldMaintenanceLimit, skip: fieldMaintenanceSkip }, () => {
            filters = `?filter[skip]=${fieldMaintenanceSkip}&filter[limit]=${fieldMaintenanceLimit}`
            this.getFieldMaintenanceList(filters)
            removeLocalStorageMasterDataItems("fieldMaintenancePaginationConstants")
          })
        } else {
          filters = `?filter[skip]=${skip}&filter[limit]=${limit}`;
          this.getFieldMaintenanceList(filters)
        }
  }


  getFieldMaintenanceList = async (filters) => {
    console.log(filters);
    
    masterDataService.getFieldMaintenanceList(filters)
      .then((response) => {
        if (response.status) {
          let responseData = response.data.data.data;
          let count = response.data.data.count;
          this.handleFiledMaintenanceListing(responseData, count);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          createNotification("error", "Your login session has been expired!");
          localStorage.setItem("user-token", "");
          this.props.history.push("/login");
          this.setState({ loader: false });
        } else {
          createNotification("error", error.response.data.error.message);
          this.setState({ loader: false });
        }
      });
  }

  handleConfirmModal = (isYes, id = "") => {
    if (isYes) {
      this.setState({
        isShowConfirmBox: !this.state.isShowConfirmBox,
        loader: true,
      });
      const { removeId ,resDataLen,pageChange} = this.state;
      let filters;
      if(resDataLen===1 && pageChange>1){
       
        let localskip =this.state.skip-this.state.limit;
        let localPage=this.state.pageChange-1;
        
      this.setState({skip:localskip,pageChange:localPage},()=>{
        filters  = `?filter[skip]=${localskip}&filter[limit]=${this.state.limit}`;
      })        
      }else{
        filters = `?filter[skip]=${this.state.skip}&filter[limit]=${this.state.limit}`;
        
      }
      masterDataService.deleteFieldMaintenanceById(removeId)
        .then((response) => {
          if (response.status) {
            createNotification("success", "FieldMaintenance item  deleted successfully");
            this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
            this.getFieldMaintenanceList(filters);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            createNotification("error", "Your login session has been expired!");
            localStorage.setItem("user-token", "");
            this.props.history.push("/login");
          } else {
            createNotification("error", error.response.data.error.message);
            this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
          }
        });
    } else {
      this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
    }
  }

  handleFiledMaintenanceListing = (responseData,count) => {
    const URL = getApiUrl();
    let listArr = [];
    responseData && responseData.map((item, index) => {

      let itemData = { ...item };
      delete item.deleted;
      itemData.role = itemData.role_fkey && itemData.role_fkey.title;
      itemData.status = itemData.status;
      itemData.project_key = index;
      listArr.push(itemData);

    });
    this.setState({ FieldMaintenanceListData: listArr,count:count ,resDataLen:responseData.length});
  }
  actionFormat = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <table>
          <th>
            <tr>
              <td>
                <ul className="list-inline mb-0">
                  <li className="list-inline-item" onClick={this.setLocalStorageItems}>
                    <Link to={`/FieldMaintenance/${row.id}`}>
                      <i className="uil uil-pen font-size-18"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <a href="javascript:void(0)" className="text-danger">
                      <i className="uil uil-trash-alt font-size-18" onClick={() => this.setState({ removeId: row.id, isShowConfirmBox: true })}></i>
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
          </th>
        </table>
      </div>
    )
  }
  setLocalStorageItems = () => {
      const { pageChange, skip, limit } = this.state;
      let data = {
        fieldMaintenancePageChange: pageChange,
        fieldMaintenanceSkip: skip,
        fieldMaintenanceLimit: limit
      }
      setLocalStorageMasterDataItems("fieldMaintenancePaginationConstants", data);
    }
  render() {

    const { FieldMaintenanceListData, isShowConfirmBox,count,pageChange,limit } = this.state;
    const handleOnTableChange = (type, newState) => {

      if (type === "sort") {
        if (newState.sortOrder == "asc") {
          FieldMaintenanceListData.sort((obj1, obj2) => {
            return obj1[newState.sortField].trim().localeCompare(obj2[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' })
              ;
          });
        } else {
          FieldMaintenanceListData.sort((obj2, obj1) => {
            return obj1[newState.sortField].trim().localeCompare(obj2[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' })
              ;
          });
        }

      }
    }

    const columns = [
      { dataField: 'name', text: 'Name', sort: true },
      { dataField: 'status', text: 'Status', sort: true },
      { dataField: " ", text: "Action", formatter: this.actionFormat }
    ];
    const sizePerPageOptions = [
      {
        text: '10',
        value: 10,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '30',
        value: 30,
      },
      {
        text: '50',
        value: 50,

      },
      {
        text: '100',
        value: 100,
      },
      // Add more options as needed
    ];
    let that=this;
    const pagination=paginationFactory({
      page:pageChange,
      sizePerPage:limit,
      lastPageText:">>",
      firstPageText:"<<",
      nextPageText:">",
      prePageText:"<",
      totalSize:count,
      hideSizePerPage:false,
      alwaysShowAllBtns:true,
      sizePerPageList:sizePerPageOptions,
      onPageChange:function(page,sizePerPage){
        let skp=(page-1)*sizePerPage;
        let filters=`?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
        that.setState({pageChange:page,skip:skp});
        that.getFieldMaintenanceList(filters);
      },
      onSizePerPageChange:function(sizePerPage,page){
        let skp=(page-1)*sizePerPage;
        that.setState({ pageChange: page, skip: skp, limit: sizePerPage});
        let filters=`?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
        that.getFieldMaintenanceList(filters);
      }
    })

    let roleKey = this.props.loginUserData.roleKey;
    const isAccess = (roleKey !== "" && rules[roleKey][Permission.MASTER_WRITE]) ? true : false;
    return (
      <div>
        {!isAccess ? <AccessDenied /> :
          <div className="main-content">
            <ConfirmBox openModal={isShowConfirmBox}
              confirmMsg="Are you sure to delete this Item?"
              handleConfirmModal={this.handleConfirmModal}
            />
            <div className="page-content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="page-title-box d-flex align-items-center justify-content-between">
                      <ol className="breadcrumb m-0">
                        <Link to={`/#`}><li className="breadcrumb-item">Home</li></Link>
                        &nbsp; / &nbsp;
                        <Link to={`/FieldMaintenance`}><li className="breadcrumb-item">Field Maintenance List</li></Link>
                      </ol>
                    </div>
                    <h4 className="mb-0">Field Maintenance Description List </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card card-block">
                      <div className="card-body">
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <Link to="/AddFieldMaintenance">
                                <button className="btn btn-success waves-effect waves-light" onClick={this.setLocalStorageItems}>
                                  <i className="uil uil-plus"></i> Add New
                                </button>
                              </Link>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-inline float-md-end mb-3">
                              <div className="search-box ms-2"></div>
                            </div>
                          </div>
                        </div>
                        <BootstrapTable
                          remote={{
                            pagination:true,
                            sort: true
                          }}
                          keyField="project_key"
                          data={FieldMaintenanceListData} columns={columns}
                          onTableChange={handleOnTableChange}
                          // pagination={paginationFactory({ sizePerPageList: sizePerPageOptions })} 
                          pagination={pagination}
                          />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

}

const mapStateToProps = (props) => {
  return {
    loginUserData: props.loginUserData,
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FieldMaintenanceList);